/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) New Message Icon component.
 */
export const SystemNewMessageIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19159)'>
        <path d='M7.22412 16.3817C7.22914 16.5151 7.28416 16.6417 7.37814 16.7361C7.47213 16.8305 7.59813 16.8857 7.73095 16.8908L10.1735 16.7681C10.2977 16.7619 10.4151 16.7096 10.5028 16.6215L20.5031 6.57691L17.4621 3.52246L7.46341 13.5654C7.37473 13.6545 7.32285 13.7737 7.3181 13.8993L7.22412 16.3817Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
        <path d='M19.3574 0.540039L23.4526 4.65336' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
        <path d='M18.2728 12.696V21.736C18.2728 22.0122 18.049 22.236 17.7728 22.236H2.26025C1.98411 22.236 1.76025 22.0122 1.76025 21.736V6.15039C1.76025 5.87425 1.98411 5.65039 2.26025 5.65039H11.5421' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19159'>
          <rect width='23' height='23' fill={dlsColor('white')} transform='translate(1)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SystemNewMessageIcon;
